import script from "./AnnouncementForm.vue?vue&type=script&setup=true&lang=js"
export * from "./AnnouncementForm.vue?vue&type=script&setup=true&lang=js"

import "./AnnouncementForm.vue?vue&type=style&index=0&id=b85adf30&scoped=true&lang=css"

import exportComponent from "C:\\wisata-jepara-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b85adf30"]])

export default __exports__